/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import dayjs from "dayjs";

import { CustomerAPIClient } from "../api_clients";
import { IAuthContext } from "../providers/CognitoAuthProvider";

import { APPLICATION_STATUS } from "enums/applicationStatus";
import { kilometerToMeter } from "helpers/distance";
import { convertHomeString } from "helpers/label";
import {
  MovementLog,
  NewMovementLog,
  MovementLogApproval,
} from "models/movementLog";

export const deleteMovementLog = async (
  auth: IAuthContext,
  movementLogId: number
) => CustomerAPIClient.del(auth, `/api/movement_logs/${movementLogId}`);

export const createMovementLog = async (
  preparedRouteId: number,
  at: string,
  isReturnPath: boolean,
  auth: IAuthContext
): Promise<MovementLog> =>
  CustomerAPIClient.post(auth, "/api/movement_logs", {
    movement_log: {
      at: dayjs(new Date(at)).locale("ja").format("YYYY-MM-DD"),
      prepared_route_id: preparedRouteId,
      account: 1,
      is_return_path: isReturnPath,
    },
  });

export const updateMovementLog = async (
  movementLogId: number,
  preparedRouteId: number,
  isReturnPath: boolean,
  auth: IAuthContext
): Promise<MovementLog> =>
  CustomerAPIClient.update(auth, `/api/movement_logs/${movementLogId}`, {
    prepared_route_id: preparedRouteId,
    is_return_path: isReturnPath,
  });

export const createTransportationExpense = async (
  auth: IAuthContext,
  movementLog: NewMovementLog
): Promise<MovementLog> =>
  CustomerAPIClient.post(auth, "/api/movement_logs", {
    // customer_api    |   Parameters: %{"movement_log" => %{"account" => 2, "arrivalCode" => "", "arrivalName" => "", "at" => "2021-02-01", "departureCode" => "", "departureName" => "", "modified_by" => 1, "movementRoutes" => [%{"arrivalName" => "b", "departureName" => "a", "distance" => 0, "fare" => 100, "orderNo" => 1, "time" => 0, "transportationType" => 1, "useCommuterPass" => false}], "totalDistance" => 0, "totalFare" => 100, "totalTime" => 0}}
    movement_log: {
      at: movementLog.at,
      departure_id: movementLog.departureId,
      departure_code: movementLog.departureCode,
      departure_name: movementLog.movementRoutes[0].departureName,
      departure_time: movementLog.departureTime,
      arrival_id: movementLog.arrivalId,
      arrival_code: movementLog.arrivalCode,
      arrival_name:
        movementLog.movementRoutes[movementLog.movementRoutes.length - 1]
          .arrivalName,
      arrival_time: movementLog.arrivalTime,
      total_fare: movementLog.totalFare,
      total_time: movementLog.totalTime,
      total_distance: kilometerToMeter(movementLog.totalDistanceKm),
      account: movementLog.account,
      prepared_route_id: movementLog.preparedRouteId,
      modified_by: movementLog.modifiedBy,
      movement_route: movementLog.movementRoutes.map((detail) => ({
        arrival_id: detail.arrivalId,
        arrival_name: detail.arrivalName,
        departure_id: detail.departureId,
        departure_name: detail.departureName,
        distance: kilometerToMeter(detail.distanceKm),
        fare: detail.fare,
        order_no: detail.orderNo,
        time: detail.time,
        transportation_type: detail.transportationType,
        use_commuter_pass: detail.useCommuterPass,
      })),
    },
  });

export const updateMovementLogApprovalStatus = async (
  auth: IAuthContext,
  id: number,
  status: keyof typeof APPLICATION_STATUS,
  formattedComment: string
): Promise<MovementLogApproval> =>
  CustomerAPIClient.update(auth, `/api/movement_log_approvals/${id}`, {
    movement_log_approval: {
      approval_status: status,
      applicant_comment: formattedComment,
    },
  });

export const getMovementRouteByAPIResponse = (movementRoute: any) => {
  const common = {
    distance: movementRoute.distance,
    distanceKm: movementRoute.distance_km,
    fare: movementRoute.fare ? movementRoute.fare : 0,
    id: movementRoute.id,
    lineId: movementRoute.line_id,
    lineName: movementRoute.line_name,
    movementLogId: movementRoute.movement_log_id,
    orderNo: movementRoute.order_no,
    time: movementRoute.time,
    transportationType: movementRoute.transportation_type,
    transportationTypeName: movementRoute.transportation_type_name,
    useCommuterPass: movementRoute.use_commuter_pass,
  };

  return {
    arrivalId: movementRoute.arrival_id,
    arrivalName: convertHomeString(movementRoute.arrival_name),
    departureId: movementRoute.departure_id,
    departureName: convertHomeString(movementRoute.departure_name),
    ...common,
  };
};
/* eslint-enable */
